export default (overrideParams) => {
  return {
    dsatUser: { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
    dsatUsersArray: [
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'False', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'False', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'False', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'KEC', label: 'KEC', demo: 'False', member_id: '' },
      { directory: 'mec', label: 'MEC', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'False', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'CREA', label: 'CREA', demo: 'False', member_id: '' },
      { directory: 'CREA', label: 'CREA', demo: 'False', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'cowlitz', label: 'cowlitz', demo: 'True', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'CPI', label: 'CPI', demo: 'False', member_id: '' },
      { directory: 'KEC', label: 'KEC', demo: 'False', member_id: '' },
      { directory: 'KEC', label: 'KEC', demo: 'False', member_id: '' },
      { directory: 'KEC', label: 'KEC', demo: 'False', member_id: '' },
      { directory: 'KEC', label: 'KEC', demo: 'False', member_id: '' },
      { directory: 'KEC', label: 'KEC', demo: 'False', member_id: '' },
      { directory: 'test', label: 'Test Customer', demo: 'False', member_id: '' }
    ]
  }
}